import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CMSUpdateLayer from "../components/CMSManagement/CMSUpdateLayer";

const CMSUpdatePage = () => {
  const { id } = useParams();

  return (
    <MasterLayout>
      <Breadcrumb title="Update CMS" />
      <CMSUpdateLayer id={id} />
    </MasterLayout>
  );
};

export default CMSUpdatePage;
